/**
 * Manages user's email preferences (used in emailPrefs component).
 */

import * as actionTypes from "../actions/actionTypes";

export default function emailPrefs(state = { optOut: null, userEmail: null, error: null }, action) {
  switch (action.type) {
    case actionTypes.FETCH_EMAIL_PREFS_SUCCESS:
    case actionTypes.SAVE_EMAIL_PREFS_SUCCESS: {
      const user = action.response.entities.users[action.response.result.user];
      return {
        prefs: user.emailPrefs,
        email: user.email,
        error: null,
      };
    }
    case actionTypes.FETCH_EMAIL_PREFS_FAILURE:
      return {
        prefs: null,
        email: null,
        error: action.error,
      };
    default:
      return state;
  }
}
